module.exports = __webpack_public_path__ + "static/img/img2.a3fb151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img2.png
// module id = OLch
// module chunks = 0